"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockDataGenerator = exports.postPayload = exports.fetchList = exports.fetchPayload = void 0;

var _lodash = require("lodash");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var snakeCasify = function snakeCasify(data) {
  var update = {};

  for (var field in data) {
    update[(0, _lodash.snakeCase)(field)] = data[field];
  }

  return update;
};

var fetchPayload = function fetchPayload(_ref) {
  var dispatch = _ref.dispatch,
      apiCall = _ref.apiCall,
      store = _ref.store,
      fetchingActionType = _ref.fetchingActionType,
      fetchedActionType = _ref.fetchedActionType,
      _ref$fetchingPayload = _ref.fetchingPayload,
      fetchingPayload = _ref$fetchingPayload === void 0 ? {} : _ref$fetchingPayload;

  if (!dispatch) {
    console.error('Missing prop dispatch');
    return;
  }

  if (!apiCall) {
    console.error('Missing prop apiCall');
    return;
  }

  var filters = null;

  if (store) {
    filters = snakeCasify(Object.assign({}, store.filters));
  }

  dispatch(_objectSpread({
    type: fetchingActionType
  }, fetchingPayload));
  var request = apiCall(filters);
  request.end(function (err, response) {
    if (err) {
      var status = err.status === 404 ? 'not found' : 'error';
      dispatch({
        type: fetchedActionType,
        status: status,
        data: {}
      });
    } else if (response.body) {
      dispatch(_objectSpread({
        type: fetchedActionType,
        status: 'success',
        data: response.body || {}
      }, fetchingPayload));
    }
  });
  return request;
};

exports.fetchPayload = fetchPayload;

var fetchList = function fetchList(_ref2) {
  var _ref2$clear = _ref2.clear,
      clear = _ref2$clear === void 0 ? false : _ref2$clear,
      dispatch = _ref2.dispatch,
      apiCall = _ref2.apiCall,
      store = _ref2.store,
      fetchingActionType = _ref2.fetchingActionType,
      fetchedActionType = _ref2.fetchedActionType,
      _ref2$fetchingPayload = _ref2.fetchingPayload,
      fetchingPayload = _ref2$fetchingPayload === void 0 ? {} : _ref2$fetchingPayload;

  if (!dispatch) {
    console.error('Missing prop dispatch');
    return;
  }

  if (!apiCall) {
    console.error('Missing prop apiCall');
    return;
  }
  /*
   * As long as a proper store is passed, we'll create a set of query parameters
   * from the filters object nested in the store. This includes things like pagination:
   * 'page_num', 'sort_by', etc, as well as any additional params like 'search_by'
   * Thus, the filters variable refers to the object that will be stringifyied into
   * a query e.g. '?search_query=marketing&search_by=name'
   */


  var filters = null;

  if (store) {
    filters = snakeCasify(Object.assign({}, store.filters));
  }

  dispatch(_objectSpread({
    type: fetchingActionType,
    clear: clear
  }, fetchingPayload));
  var request = apiCall(filters);
  request.end(function (err, response) {
    if (err) {
      var status = err.status === 404 ? 'not found' : 'error';
      dispatch({
        type: fetchedActionType,
        status: status,
        data: []
      });
    } else {
      dispatch(_objectSpread({
        type: fetchedActionType,
        data: response.body.resources,
        pagination: response.body.pagination,
        interval: filters ? filters.time_interval : null,
        status: 'success'
      }, fetchingPayload, {
        clear: clear
      }));
    }
  });
  return request;
};

exports.fetchList = fetchList;

var postPayload = function postPayload(_ref3) {
  var dispatch = _ref3.dispatch,
      apiCall = _ref3.apiCall,
      fetchingActionType = _ref3.fetchingActionType,
      fetchedActionType = _ref3.fetchedActionType,
      payload = _ref3.payload,
      fetchedPayload = _ref3.fetchedPayload,
      fetchingPayload = _ref3.fetchingPayload;

  if (!payload || Object.keys(payload).length === 0) {
    console.error('Invalid payload. You must pass a valid object');
    return;
  }

  if (!dispatch) {
    console.error('Missing prop dispatch');
    return;
  }

  if (!apiCall) {
    console.error('Missing prop apiCall');
    return;
  }

  dispatch(_objectSpread({
    type: fetchingActionType
  }, fetchingPayload));
  return apiCall(payload).end(function (err, response) {
    if (err) {
      var status = err.status === 404 ? 'not found' : 'error';
      dispatch(_objectSpread({
        type: fetchedActionType,
        status: status,
        data: {}
      }, fetchedPayload));
    } else if (response.ok) {
      dispatch(_objectSpread({
        type: fetchedActionType,
        status: 'success',
        data: response.body || {}
      }, fetchedPayload));
    }
  });
};
/**
 *
 * @param {Object} fakeData
 * @param {Integer} timeout
 */


exports.postPayload = postPayload;

var mockDataGenerator = function mockDataGenerator(fakeData) {
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;

  /**
   *  Replace the fetch call by a promise. The data returned need to
   * fit the XHR response format, so we pass it in a body var.
   */
  var prom = new Promise(function (resolve) {
    var data = {
      body: fakeData
    }; // in order to test all the possible states, we need it to be delayed by a timeout.
    // Once the timeout is passed, we resolve the promise with the data.

    setTimeout(function () {
      return resolve(data);
    }, timeout);
  }); // we use the fetch.end method instead of then in order to get proper error handling.
  // in order to spoof this, we recreate this method by adding the callback to then and
  // setting the error to null to match the (err, response) format.

  return {
    end: function end(callback) {
      prom.then(function (data) {
        return callback(null, data);
      });
      return {
        abort: function abort() {}
      };
    }
  };
};

exports.mockDataGenerator = mockDataGenerator;

//# sourceMappingURL=index.js.map